// React Required
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Checkout from './Checkout';

// Create Import File
import './index.scss';

// Common Layout
// import Layout from "./component/common/App";

// Home layout
// import Demo from './page-demo/Demo';
// import MainDemo from './home/MainDemo';
// import Startup from './home/Startup';
// import Paralax from './home/Paralax';
// import HomePortfolio from './home/HomePortfolio';
// import DigitalAgency from './home/DigitalAgency';
// import CreativeAgency from './home/CreativeAgency';
// import PersonalPortfolio from './home/PersonalPortfolio';
// import Business from './home/Business';
import MoonlineHome from './Views/Home/MoonlineHome';
// import PortfolioLanding from './home/PortfolioLanding';
// import CreativeLanding from './home/CreativeLanding';
// import HomeParticles from './home/HomeParticles';
// import CreativePortfolio from './home/CreativePortfolio';
// import DesignerPortfolio from './home/DesignerPortfolio';
// import InteriorLanding from './home/Interior';
// import CorporateBusiness from './home/CorporateBusiness';

// Dark Home Layout
// import DarkMainDemo from './dark/MainDemo';
// import DarkPortfolioLanding from './dark/PortfolioLanding';

// Element Layout
// import Service from "./elements/Service";
// import ServiceDetails from "./elements/ServiceDetails";
import About from './Views/About/About';
import Contact from './Views/Contact/Contact';
import Residential from './Views/Services/Residential/Residential';
import Commercial from './Views/Services/Commercial/Commercial';
import Packing from './Views/Services/Packing/Packing';
import MovingType from './Views/Services/MovingType/MovingType';
import LongDistance from './Views/Services/LongDistance/LongDistance';
import LargeAndHeavy from './Views/Services/LargeAndHeavyItem/LargeAndHeavy';
import Piano from './Views/Services/Piano/Piano';
import Storage from './Views/Services/Storage/Storage';
import ClientInformation from './Views/Stepper/ClientInformation';
import MoveDetails from './Views/Stepper/MoveDetails';
import Reserve from './Views/Stepper/Reserve';
import RequestQuote from './Views/Stepper/RequestQuote';
import FinalCost from './Views/Stepper/FinalCost';
import PaymentDetails from './Views/Stepper/PaymentDeatils';
import ThankYou from './Views/Stepper/ThankYou';
import LocalMoving from "./Views/LocalMoving/LocalMoving";
// import FurnitureAssembly from "./Views/FurnitureAssembly/FurnitureAssembly";
import FurnitureMoving from "./Views/FurnitureMoving/FurnitureMoving";
import HeavyMoving from "./Views/HeavyMoving/HeavyMoving";
import LongMoving from "./Views/LongMoving/LongMoving";
import Tips from './Views/Tips/Tips';
import Track from './Views/Track/Track';
import Moving from './Views/Moving/Moving';
import MovingGuide from "./Views/Blog/MovingGuide/MovingGuide";
import BadWeather from "./Views/Blog/BadWeather/BadWeather";
import MovingChecklist from "./Views/Blog/MovingChecklist/MovingChecklist";
import MovingTips from "./Views/Blog/MovingTips/MovingTips";
import ReliableMove from "./Views/Blog/ReliableMove/ReliableMove";
import BlogDetails from "./Views/Blog/BlogDetails/BlogDetails";
// // import BlogDetails from "./elements/BlogDetails";
// import error404 from "./elements/error404";

// Blocks Layout

// import Team from "./blocks/Team";
// import Counters from "./blocks/Counters";
// import Testimonial from "./blocks/Testimonial";
// import Portfolio from "./blocks/Portfolio";
// import VideoPopup from "./blocks/VideoPopup";
// import Gallery from "./blocks/Gallery";
// import Brand from "./blocks/Brand";
// import ProgressBar from "./blocks/ProgressBar";
// import ContactForm from "./blocks/ContactForm";
// import GoogleMap from "./blocks/GoogleMap";
// import Columns from "./blocks/Columns";
// import PricingTable from "./blocks/PricingTable";

import { BrowserRouter, Switch, Route } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';

class Root extends Component {
	render() {
		return (
     
			<BrowserRouter basename={'/'}>
				<Switch>
					{/* <Route exact path={`/demo`} component={Demo}/>
                    <Route exact path={`/main-demo`} component={MainDemo}/>
                    <Route exact path={`/dark-main-demo`} component={DarkMainDemo}/>
                    <Route exact path={`/startup`} component={Startup}/>
                    <Route exact path={`/paralax`} component={Paralax}/>
                    <Route exact path={`/digital-agency`} component={DigitalAgency}/>
                    <Route exact path={`/creative-agency`} component={CreativeAgency}/>
                    <Route exact path={`/personal-portfolio`} component={PersonalPortfolio}/> */}
					<Route exact path={`/`} component={MoonlineHome} />
					{/* <Route exact path={`/business`} component={Business}/>
                    <Route exact path={`/portfolio-home`} component={HomePortfolio}/>
                    <Route exact path={`/portfolio-landing`} component={PortfolioLanding}/>
                    <Route exact path={`/creative-landing`} component={CreativeLanding}/>
                    <Route exact path={`/home-particles`} component={HomeParticles}/>
                    <Route exact path={`/dark-portfolio-landing`} component={DarkPortfolioLanding}/>
                    <Route exact path={`/designer-portfolio`} component={DesignerPortfolio}/>
                    <Route exact path={`/creative-portfolio`} component={CreativePortfolio}/>
                    <Route exact path={`/interior-landing`} component={InteriorLanding}/>
                    <Route exact path={`/corporate-business`} component={CorporateBusiness}/> */}


                    {/* Header Pages */}
                    <Route exact path={`/tips`} component={Tips}/>
                    <Route exact path={`/track`} component={Track}/>
                    <Route exact path={`/contact`} component={Contact}/>
                    <Route exact path={`/commercial`} component={Commercial}/>
                    <Route exact path={`/residential`} component={Residential}/>
                    <Route exact path={`/MovingType`} component={MovingType}/>
                    <Route exact path={`/piano`} component={Piano}/>
                    <Route exact path={`/packing`} component={Packing}/>
                    <Route exact path={`/moving`} component={Moving}/>
                    {/* Stepper Form */}
                    <Route exact path={`/contact`} component={Contact}/>
                    <Route exact path={`/clientinformation`} component={ClientInformation}/>
                    <Route exact path={`/movedetails`} component={MoveDetails}/>
                    <Route exact path={`/reserve`} component={Reserve}/>
                    <Route exact path={`/requestquote`} component={RequestQuote}/>
                    <Route exact path={`/about`} component={About}/>

                    {/* Our Services Section */}
                    
                    <Route exact path={`/localmoving`} component={LocalMoving}/>
                    <Route exact path={`/longmoving`} component={LongMoving}/>
                    <Route exact path={`/furnituremoving`} component={FurnitureMoving}/>
                    {/* <Route exact path={`/furnitureassembly`} component={FurnitureAssembly}/> */}
                    <Route exact path={`/heavymoving`} component={HeavyMoving}/>
                    <Route exact path={`/storage`} component={Storage}/>
                  {/*<Route exact path={`/portfolio-details`} component={PortfolioDetails}/> */}
                    {/* <Route exact path={`/blog`} component={Blog}/> */}
                    {/* <Route exact path={`/blog-details`} component={BlogDetails}/> */}


                    {/* Blocks Elements  */}
                    {/* <Route exact path={`/team`} component={Team}/> */}
                    {/* <Route exact path={`/counters`} component={Counters}/>
					{/* Header Pages */}
					<Route exact path={`/commercial`} component={Commercial} />
					<Route exact path={`/residential`} component={Residential} />
					<Route exact path={`/MovingType`} component={MovingType} />
					<Route exact path={`/longDistance`} component={LongDistance} />
					<Route exact path={`/large-and-heavy`} component={LargeAndHeavy} />
					<Route exact path={`/piano`} component={Piano} />
					<Route exact path={`/storage`} component={Storage} />
					<Route exact path={`/packing`} component={Packing} />
					<Route exact path={`/moving`} component={Moving} />
					<Route exact path={`/tips`} component={Tips} />
					<Route exact path={`/track`} component={Track} />
					<Route exact path={`/contact`} component={Contact} />
					{/* Stepper Form */}
					<Route exact path={`/contact`} component={Contact} />
					<Route exact path={`/clientinformation`} component={ClientInformation} />
					<Route exact path={`/movedetails`} component={MoveDetails} />
					<Route exact path={`/reserve`} component={Reserve} />
					<Route exact path={`/requestquote`} component={RequestQuote} />
					<Route exact path={`/finalcost`} component={FinalCost} />
					<Route exact path={`/paymentdetails`} component={PaymentDetails} />
					<Route exact path={`/thankyou`} component={ThankYou} />
					<Route exact path={`/about`} component={About} />

                    {/*Blog Posts */}
                    <Route exact path={`/movingguide`} component={MovingGuide} />
					<Route exact path={`/badweather`} component={BadWeather} />
					<Route exact path={`/movingtips`} component={MovingTips} />
					<Route exact path={`/movingchecklist`} component={MovingChecklist} />
					<Route exact path={`/reliablemove`} component={ReliableMove} />
                    <Route exact path={`/blogdetails`} component={BlogDetails} />

					{/*<Route exact path={`/portfolio-details`} component={PortfolioDetails}/> */}
					{/* <Route exact path={`/blog`} component={Blog}/> */}
					{/* <Route exact path={`/blog-details`} component={BlogDetails}/> */}

					{/* Blocks Elements  */}
					{/* <Route exact path={`/team`} component={Team}/> */}
					{/* <Route exact path={`/counters`} component={Counters}/>
                    <Route exact path={`/testimonial`} component={Testimonial}/>
                    <Route exact path={`/portfolio`} component={Portfolio}/> */}
					{/* <Route exact path={`/video-popup`} component={VideoPopup}/>
                    <Route exact path={`/gallery`} component={Gallery}/>
                    <Route exact path={`/clint-logo`} component={Brand}/>
                    <Route exact path={`/progressbar`} component={ProgressBar}/>
                    <Route exact path={`/contact-form`} component={ContactForm}/> */}
					{/* <Route exact path={`/google-map`} component={GoogleMap}/> */}
					{/* <Route exact path={`/columns`} component={Columns}/>
                    <Route exact path={`/pricing-table`} component={PricingTable}/> */}

					{/* <Route path={`/404`} component={error404}/>
                    <Route component={error404}/> */}
				</Switch>
			</BrowserRouter>
		);
	}
}

ReactDOM.render(<Root />, document.getElementById('root'));
serviceWorker.register();
